import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZoomAndMoveDirective } from './zoom-and-move.directive';

@NgModule({
  imports: [

  ],
  declarations: [ZoomAndMoveDirective],
  exports: [ZoomAndMoveDirective]
})
export class ShareDirectiveModule { }
